import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ReportLogOfEvents } from '@report/models/report-of-event-log';
import { StaticMessage } from '@shared/enums';

@Component({
  selector: 'app-report-log-of-events',
  templateUrl: './report-log-of-events.component.html',
  styleUrls: ['./report-log-of-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportLogOfEventsComponent {
  @Input({ required: true }) reportLogOfEvents: ReportLogOfEvents[];
  @Input({ required: true }) enableEventsLogActivityGroupsOnly: boolean;

  StaticMessage = StaticMessage;
  eventLogPrefix = $localize`:@@report.reportLogOfEvents.lblAccumActivityDurationStats:Accum. activity duration stats: `;
}
